export default "__VITE_ASSET__wBSlvgHl__"